<template>
  <div
    class="w-full bg-bg-canvas rounded-xl p-3.5 border border-transparent"
    @dragover.prevent
    @drop.prevent="handleDrop"
  >
    <slot name="body" />
    <div class="flex flex-col items-center justify-center gap-3" :class="computedHeight">
      <Icon name="Upload" class="h-6 w-6 text-radio-checkbox-outline" />
      <p class="text-sm text-strongest font-inter">
        Drag the file here or click select and upload your files
      </p>
      <Button @click="openFileDialog" variant="paper-primary" size="lg-md">
        <template #label>Upload Files</template>
      </Button>
      <p v-if="errorMessage" class="text-error text-center text-sm mt-2">
        {{ errorMessage }}
      </p>
      <input
        ref="fileInput"
        type="file"
        class="hidden"
        :accept="dataStore?.accepted_file_extensions?.join(', ')"
        @change="handleFilesSelected"
        :multiple="!selectOne"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

import { useDataStore } from "@/stores";
import { Icon, Button } from "@/components";
import { isValidFile } from "@/utilities";

const dataStore = useDataStore();
const props = defineProps({
  selectOne: {
    type: Boolean,
    default: false,
  },
  customHeight: {
    type: String,
    default: "",
  },
});
const emit = defineEmits(["files-selected"]);

const fileInput = ref(null);
const dragOver = ref(false);
const errorMessage = ref("");

const computedHeight = computed(() => props.customHeight || "h-64");

function processFiles(rawFiles) {
  errorMessage.value = "";

  for (const file of rawFiles) {
    if (!isValidFile(file)) {
      errorMessage.value = `File "${file.name}" contains an invalid type or restricted file extensions.`;
      return;
    }
  }

  emit("files-selected", rawFiles);
}

const openFileDialog = () => {
  fileInput.value.click();
};

const handleFilesSelected = (event) => {
  const rawFiles = Array.from(event.target.files);
  processFiles(rawFiles);
};

const handleDragOver = () => {
  dragOver.value = true;
};

const handleDragLeave = () => {
  dragOver.value = false;
};

function handleDrop(event) {
  dragOver.value = false;

  let rawFiles = Array.from(event.dataTransfer.files);
  if (props.selectOne && rawFiles.length > 1) {
    rawFiles = [rawFiles[0]];
  }

  processFiles(rawFiles);
}
</script>
